<div class="loaderContainer">
  <mat-spinner class="loading-spinner"></mat-spinner>
  <span class="loadingText">{{ text | translate}}</span>
</div>
